import React, { useEffect } from "react";
import Common_Title_1 from "../../../../common/common_components/common_title_1/Common_Title_1";
import Pink_Btn from "../../../../common/common_btn/pink_btn/Pink_Btn";
import { AllShippingAndDeliveryPolicy } from '../../../../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";


const Shipping_Delivery_Policy = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const shipping_delivery_policy = useSelector((state) => state.footer.shipping_delivery_policy);

  // console.log("all_shipping_delivery_policy",shipping_delivery_policy)

  useEffect(() => {
    dispatch(AllShippingAndDeliveryPolicy());
  }, [dispatch]);


  return (
    <section className="Shipping_Delivery_Policy Privacy_Policy">
      <Common_Title_1 subText="Shipping & Delivery Policy" />

      <p className="">{parse(shipping_delivery_policy?.content || "")}</p>

      <div className="btn_holder">
        <Pink_Btn btnText={"OK"} onClick={() => { navigate("/settings/menu") }} />
      </div>
    </section>
  );
};

export default Shipping_Delivery_Policy;
